/**
 * Created by siroramirez on 09/02/17.
 */
import { Injectable }   from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';
 
@Injectable()
export class ApiService {
    
    constructor (private configurationService: ConfigurationService) {}

    getBaseUrl(){
        return this.configurationService.getConfigurationKey("baseURL");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/network/api.service.ts